export default __webpack_public_path__ + "static/svg-5-b6db0a3978082a9719b22ad6ba2b4094.svg";